import { connect } from 'react-redux';

import { selectTrackElement } from 'redux/modules/embed/actions/tracks';
import {
  aspectRatioSelector,
  getTrackAssetsSelector,
} from 'redux/modules/embed/selectors';
import { pushModal } from 'redux/modules/modal/actions';
import { Dispatch, State } from 'redux/types';
import { PropsOf } from 'types';
import MediaTrack, { MediaTrackProps as Props } from './MediaTrack';

type StateProps = Pick<Props, 'assets' | 'projectAspectRatio'>;
type DispatchProps = Pick<Props, 'onAssetClick'>;
type OwnProps = Pick<Props, 'id'>;

const makeMapStateToProps = () => {
  return (state: State, props: OwnProps): StateProps => ({
    assets: getTrackAssetsSelector(props.id)(state),
    projectAspectRatio: aspectRatioSelector(state),
  });
};

const mapDispatchToProps = (
  dispatch: Dispatch,
  props: OwnProps,
): DispatchProps => ({
  onAssetClick: (id, type) => {
    dispatch(selectTrackElement(id, props.id));

    if (type === 'image') {
      dispatch(pushModal({ name: 'EditSlideModal' }));
    } else {
      dispatch(pushModal({ name: 'EditVideoModal' }));
    }
  },
});

const component = connect(makeMapStateToProps, mapDispatchToProps)(MediaTrack);

export default component;
export type MediaTrackProps = PropsOf<typeof component>;
